const styles = (theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: theme.palette.primary.dark,
  },
  icon: {
    marginRight: theme.spacing.unit * 0.75,
    width: 20,
    height: 20,
  },
});

export default styles;
